import React from "react";
import SigninRegisterModal from "../../components/modal/signin-register-modal";
import { Swiper, SwiperSlide } from "swiper/react";
import { Mousewheel, Virtual } from "swiper/modules";
import "swiper/css";
import "swiper/css/virtual";
import AppFooterWeb from "../../components/AppFooterWeb";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  selectHomeData,
  selectemployeeData,
} from "../../store/home/home.selectors";
import {
  homeSyncStart,
  updateHomeSlideId,
  updateShowResetPasswordOverlayFlag,
} from "../../store/home/home.actions";
import AppConfig from "../../config/app.config";
import Banner from "../../components/banners/Banner";
import { Link } from "react-router-dom";
import { Backdrop, CircularProgress } from "@mui/material";

export var swiper = null;

const mapStateToProps = (state) => {
  return {
    homeData: selectHomeData(state),
    employeeData: selectemployeeData(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(
    {
      homeSyncStart,
      updateHomeSlideId,
      updateShowResetPasswordOverlayFlag,
    },
    dispatch
  ),
});

export class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: 0,
      isSigninRegisterModalVisible: false,
      bannerList: null,
      isWebView: window.innerWidth > 767,
    };
    this.isInitialScrolled = false;
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    window.addEventListener("resize", this.resizeListener);
    if (this.props.location?.pathname?.startsWith("/reset-password")) {
      this.props.updateShowResetPasswordOverlayFlag();
    }
    const { homeSyncStart, homeData } = this.props;
    const payload = {
      appId: AppConfig.API.APP_ID,
      subscriptionId: AppConfig.API.SUBSCRIPTION_ID,
      verticalId: AppConfig.API.VERTICAL_ID,
      loginEmployeeId: this.props.employeeData?.employeeId,
      timeZone: Intl.DateTimeFormat()?.resolvedOptions()?.timeZone,
    };
    if (
      (homeData.initialSynced && homeData.bannerList !== null) ||
      homeData.bannerList !== this.state.bannerList
    ) {
      this.setState({ bannerList: homeData.bannerList }, () => {
        if (!this.isInitialScrolled) {
          if (
            this.props.match?.params?.projectId != null &&
            this.state.bannerList != null
          ) {
            const index = this.state.bannerList.findIndex(
              (x) => `${x.projectId}` === `${this.props.match.params.projectId}`
            );
            if (index !== -1) {
              swiper?.slideTo(this.state.isWebView ? index + 2 : index + 1);
            }
          }
          this.isInitialScrolled = true;
        }
      });
    } else {
      this.setState({ isLoading: 1 });
      homeSyncStart(payload);
    }
    this.props.updateHomeSlideId(null);
  }

  async componentDidUpdate(prevProps, prevState) {
    const { homeData } = this.props;
    if (
      homeData.initialSynced &&
      homeData.bannerList !== prevProps.homeData.bannerList
    ) {
      if (this.state.bannerList !== homeData.bannerList) {
        this.setState(
          {
            bannerList: homeData.bannerList,
            isLoading: 0,
          },
          () => {
            if (!this.isInitialScrolled) {
              if (
                this.props.match?.params?.projectId != null &&
                this.state.bannerList != null
              ) {
                const index = this.state.bannerList.findIndex(
                  (x) =>
                    `${x.projectId}` === `${this.props.match.params.projectId}`
                );
                if (index !== -1) {
                  swiper?.slideTo(this.state.isWebView ? index + 2 : index + 1);
                }
              }
              this.isInitialScrolled = true;
            }
          }
        );
      }
    }
    if (homeData.syncingHome !== prevProps.homeData.syncingHome) {
      this.setState({
        isLoading: homeData.syncingHome ? 1 : 0,
      });
    }
    if (
      this.props.match?.params?.projectId !== prevProps.match?.params?.projectId
    ) {
      this.isInitialScrolled = false;
    }
  }

  componentWillUnmount() {
    swiper = null;
    this.props.updateHomeSlideId(null);
    window.removeEventListener("resize", this.resizeListener);
  }

  resizeListener = () => {
    const isWebWidth = window.innerWidth > 767;
    if (this.state.isWebView !== isWebWidth) {
      this.setState(
        {
          isWebView: isWebWidth,
        },
        () => swiper?.update()
      );
    }
  };

  render() {
    return (
      <div className="banner-section">
        {this.state.isLoading === 1 && (
          <Backdrop style={{ zIndex: 9999999, color: "#fa96c8" }} open>
            <CircularProgress color="inherit" />
          </Backdrop>
        )}
        <Swiper
          autoHeight={true}
          direction={"vertical"}
          onSwiper={(s) => (swiper = s)}
          spaceBetween={0}
          mousewheel={{
            releaseOnEdges: true,
          }}
          modules={[Mousewheel, Virtual]}
          className="mySwiper"
          onSlideChange={(swiper) => {
            if (
              (this.state.isWebView && swiper.activeIndex < 2) ||
              (!this.state.isWebView && swiper.activeIndex < 1)
            ) {
              this.props.updateHomeSlideId(null);
            } else {
              const projectId =
                this.state.bannerList[
                  this.state.isWebView
                    ? swiper.activeIndex - 2
                    : swiper.activeIndex - 1
                ]?.projectId;
              this.props.updateHomeSlideId(
                projectId === "" ? null : projectId ?? null
              );
            }
          }}
          virtual={{
            enabled: true,
            addSlidesAfter: 10,
            addSlidesBefore: 10,
            cache: true,
          }}
        >
          <SwiperSlide className="swiper-banner">
            <div className="banner banner-img"></div>
            <div className="down-arrowimg">
              <img
                onClick={() => swiper?.slideNext()}
                src={require("../../assets/images/Down-arrow.png")}
                alt="Down-arrow"
                className="Down-arrow"
              ></img>
            </div>
            <div className="mobile-view">
              <div className="banner-mobile-img">
                {/* <img
                  src={require("../../assets/images/home-mobile-banner.png")}
                  alt="logo"
                  className="mobile-view-banner"
                ></img> */}
              </div>
              <div className="mobile-about-text">
                <img
                  src={require("../../assets/images/Drexel-logo.png")}
                  alt="logo"
                  className="drexel-logo"
                ></img>
                <p>
                  In 1967 Larry Magid returned to his native Philadelphia,
                  reconnecting with brothers Allen, Herb and Jerry Spivak, and
                  Shelly Kaplan. Herb Spivak owned a jazz nightspot called the
                  Showboat Theatr and was keen to harness Larry Magid’s
                  experience as a talent agent in New York, who had been
                  promoting upcoming rock and blues musicians. The two discussed
                  plans to open a club that would be a hip, underground
                  environment.
                </p>
                <Link to="/about">learn more</Link>
              </div>
            </div>
          </SwiperSlide>
          {this.state.isWebView && (
            <SwiperSlide className="about-mobilesec">
              <div className="banner banner-description">
                <p>
                  In 1967 Larry Magid returned to his native Philadelphia,
                  reconnecting with brothers Allen, Herb and Jerry Spivak, and
                  Shelly Kaplan. Herb Spivak owned a jazz nightspot called the
                  Showboat Theatr and was keen to harness Larry Magid’s
                  experience as a talent agent in New York, who had been
                  promoting upcoming rock and blues musicians. The two discussed
                  plans to open a club that would be a hip, underground
                  environment. <br></br>
                  <br></br>
                  When the original Electric Factory opened on Arch Street in
                  February 1968, Philadelphia had a range of venues offering
                  jazz, blues, soul, rhythm & blues, and rock, supported by
                  local radio stations. Yet its impact was immediate, with Jimi
                  Hendrix, Janis Joplin and Cream appearing in its first three
                  months. Electric Factory Concerts (EFC) began shortly
                  afterwards, mounting the three-day Atlantic City Pop Festival
                  in 1969, just before Woodstock. Shortly after the original
                  Electric Factory closed in 1970, EFC opened the Bijou Café on
                  Lombard St.<br></br>
                  <br></br>
                  With Larry Magid, as promoter, and Allen Spivak as business
                  manager, EFC became the major concert producer on the east
                  coast, managing thousands of concerts at the Spectrum and
                  other venues. It co-produced Live Aid, partnering with Bob
                  Geldorf, Bill Graham, and Harvey Goldsmith in London, and
                  twenty years later Live 8. In 1995, the second Electric
                  Factory opened in Old City.<br></br>
                  <br></br>
                  This unmissable exhibition will include original posters,
                  photographs, and concert apparel. An American invention, the
                  electric guitar is the signature instrument of rock and
                  visitors will be drawn to Bruce Springsteen’s Fender
                  Telecaster, played in Philadelphia more than any other
                  celebrated guitar; the 6-string bass Jack Bruce used to record
                  Fresh Cream, painted in psychedelic colors for Cream’s 1968
                  European and US tours; and a late 1950s Gibson Les Paul,
                  regarded by some as the holy grail of electric guitars, played
                  by Mick Taylor at the Spectrum during the Stones’ tour in
                  1972.<br></br>
                  <br></br>
                  The exhibition includes sections on the early years of
                  Electric Factory, Live Aid, concert sound systems (with a
                  scaled-down stage), the 2nd Electric Factory, and the
                  psychology of rhythm which underlies so much music. An
                  interactive section will close the show, inviting guests to
                  decorate guitars virtually. <br></br>
                </p>
                <div className="down-arrowimg">
                  <img
                    onClick={() => swiper?.slideNext()}
                    src={require("../../assets/images/Down-arrow.png")}
                    alt="Down-arrow"
                    className="Down-arrow"
                  ></img>
                </div>
              </div>
            </SwiperSlide>
          )}
          {this.state.bannerList != null &&
            this.state.bannerList.map((banner, index) => {
              return (
                <SwiperSlide
                  className={index % 2 === 0 ? "left-banner" : "right-banner"}
                  id={banner?.projectId}
                  key={banner?.projectId}
                  virtualIndex={index}
                >
                  <Banner
                    bannerData={banner}
                    showSigninRegisterModal={() =>
                      this.setState({
                        isSigninRegisterModalVisible: true,
                      })
                    }
                  />
                </SwiperSlide>
              );
            })}
          <SwiperSlide id="footer-slide" className="hide-footersection">
            <AppFooterWeb
              pathName={this.props.location?.pathname}
              history={this.props.history}
            />
          </SwiperSlide>
        </Swiper>

        <SigninRegisterModal
          show={this.state.isSigninRegisterModalVisible}
          hideModal={() =>
            this.setState({ isSigninRegisterModalVisible: false })
          }
        />
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Home);
